'use client';
import { userPrincipalAtom } from '@/atoms-store/user-atoms';
import useCookie from '@/common/hooks/useCookie';
import { getStatus, redirectToLogin } from '@/common/services/api.service';
import { COOKIE_KEY } from '@/types/cookie';
import { UserPayload } from '@/types/userPayload';
import { useAtom } from 'jotai';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

export default function DecidePage() {
	const { setCookie, getCookie } = useCookie();
	const router = useRouter();
	const [userContext, setUserContext] = useAtom<UserPayload>(userPrincipalAtom);

	const decide = async () => {
		// For demonstration purposes, we're setting a mock token
		// setCookie(COOKIE_KEY, 'eyJraWQiOiJBMDJpbTBVMTR1WmVvZ1VXIiwiYWxnIjoiUlMyNTYiLCJ0eXAiOiJKV1QifQ.eyJhdWQiOiJJWlE3QVVMV0dteHdmRzlIYjl5WjZDOFRCQzhNREJVVSIsInN1YiI6IjEwMDAyIiwiaXNzIjoiaHR0cHM6Ly9zYWFzLm5leHRzY20uY29tL2FjY291bnQyIiwiZXhwIjoxNzI0MDY0NDU3LCJpYXQiOjE3MjQwNjA4NTcsImF1dGhfdGltZSI6MTcyMjI0NTA4OCwibmFtZSI6ImFkbWluIiwidXNlcm5hbWUiOiJhZG1pbiIsImF1dGhfbW9kZSI6IkJBU0lDIiwib3JnX25hbWUiOiJpbmNyZWZmIiwiYXBwX25hbWUiOiJhY2NvdW50Iiwib3JnX2lkIjoxMDAwMywic2lkIjoiOGE1MDNiY2Q2ZGFhNTg3NTM1ODQwZWFhNTVmZTVjNDk2MzliYTQxZiIsIm9yZ19yb2xlcyI6IltcImFkbWluXCIsXCJzdXBlcmFkbWluXCIsXCJtYW5hZ2VyXCJdIiwiYXBwX3JvbGVzIjoie1wiYXNzdXJlXCI6W1wiYWRtaW5cIixcImd1ZXN0XCJdLFwiYWNjb3VudFwiOltcInN0YW5kYXJkXCIsXCJpbnRlZ3JhdGlvblwiLFwiYWRtaW5cIixcImd1ZXN0XCJdfSIsInJlc291cmNlX3JvbGVzIjoie1wiYXNzdXJlXCI6e1wic3VwcGxpZXJcIjp7XCJzdXBwbGllcjNcIjpbXCJwYXJ0bmVyXCJdLFwic3VwcGxpZXIyXCI6W1wiZGlzdHJpYnV0ZXJcIixcInZlbmRlclwiXSxcInN1cHBsaWVyMVwiOltcInBhcnRuZXJcIixcImRpc3RyaWJ1dGVyXCIsXCJ2ZW5kZXJcIl19LFwiY2xpZW50XCI6e1wiY2xpZW50MlwiOltcImNsaWVudC5zdGFuZGFyZFwiLFwiY2xpZW50LmFkbWluXCJdLFwiY2xpZW50MVwiOltcImNsaWVudC5zdGFuZGFyZFwiLFwiY2xpZW50LmFkbWluXCJdLFwiY2xpZW50MFwiOltcImNsaWVudC5zdGFuZGFyZFwiLFwiYWRtaW5cIixcImNsaWVudC5hZG1pblwiXX0sXCJ3YXJlaG91c2VcIjp7XCJ3YXJlaG91c2UxXCI6W1wiYWRtaW5cIixcIndoLnBpY2tlci1wYWNrZXJcIixcIndoLm1hbmFnZXJcIl19fX0ifQ.OpvThaAKK6lspQgjTOXBfYcpEt0iQX_FeyF7EK02utQzOdq-XIw45sSXJj7G8FY5buPQYacEl4BfLr2jQNxHlrU3NIiFA9lO140re9c9ee4SDg8MER4y3VUbUj0wmK-zS5MUjwktAZUGFvcRyO9Yf_26Fq9KXxO_jPc8sP5WvxqCgbXzqx9kLI4xJ-aDfFY3sLKUMITzJEAkq4RT7xEJbxIUaWQ_Ug5Zag66lcIg7ejEgTT-j-2js43cJ_zgQJvO4D05Gx4l2NeULX-3BWN1NTrHmmwH4cRc2-OllDFZacOPZTBPAw41lWSL3oIQm_FkEan2SgMnTHFquWUOTyv0ZA', 1);
		// const cookieValue = getCookie(COOKIE_KEY);
		// console.log("🚀 ~ decide ~ cookieValue:", cookieValue);

		try {
			// const decodedToken = jwtDecode(cookieValue) as UserPayload;
			// console.log("🚀 ~ decide ~ jwtDecode:", decodedToken);

			const userDetail: UserPayload = await getStatus();
			setUserContext(userDetail);

			localStorage.setItem('userPayload', JSON.stringify(userDetail));

			const orgRoles = userDetail.orgRoles || [];
			const appRoles = userDetail.appRoles || {};
			const resourceRoles: Record<string, Record<string, Record<string, Array<string>>>> = userDetail.resourceRoles || {};

			// Check conditions and redirect
			if (orgRoles.includes('superadmin')) {
				console.log('Redirecting to admin applications');
				router.push('/admin/applications');
			} else if (orgRoles.includes('admin') || orgRoles.includes('manager')) {
				console.log('Redirecting to domain user from org roles');
				router.push('/domain/users');
			} else if (Object.values(appRoles).some(roles => roles.includes('admin'))) {
				console.log('Redirecting to domain usser page from app roles');
				router.push('/domain/users');
			} else if (Object.values(resourceRoles).some(category => 
							Object.values(category).some(resource => 
								Object.values(resource).some(roles => roles.includes('admin'))
			))) {
				console.log('Redirecting to domain user page from resource roles');
				router.push('/domain/users');
			} else {
				console.log('Redirecting to profile page');
				router.push('/domain/profile');
			}
		} catch (error) {
			console.error('Error decoding or parsing token:', error);
			redirectToLogin();
			// router.push('/not-found');
		}
	};

	useEffect(() => {
		console.log('Decide page');
		decide();
	}, []);

	return (<></>);
}

/**
{
	"aud": "IZQ7AULWGmxwfG9Hb9yZ6C8TBC8MDBUU",
	"sub": "10002",
	"iss": "https://saas.nextscm.com/account2",
	"exp": 1722248696,
	"iat": 1722245096,
	"auth_time": 1722245088,
	"name": "admin",
	"username": "admin",
	"auth_mode": "BASIC",
	"org_name": "increff",
	"app_name": "account",
	"org_id": 10003,
	"sid": "8a503bcd6daa587535840eaa55fe5c49639ba41f",
	"org_roles": "[\"admin\",\"manager\",\"superadmin\"]", -> json parse
	"app_roles": "{\"assure\":[\"admin\",\"guest\"],\"account\":[\"standard\",\"integration\",\"admin\",\"guest\"]}", -> json parse
	"resource_roles": "{\"assure\":{\"supplier\":{\"supplier3\":[\"partner\"],\"supplier2\":[\"admin\",\"distributer\"],\"supplier1\":[\"partner\",\"distributer\",\"vender\"]},\"client\":{\"client\":[\"admin\"],\"client2\":[\"client.standard\",\"client.admin\"],\"client1\":[\"client.standard\",\"client.admin\"],\"client0\":[\"client.standard\",\"client.admin\"]},\"warehouse\":{\"warehouse1\":[\"wh.picker-packer\"]}}}" -> json parse
}
*/
